/* eslint-disable class-methods-use-this */

import {AtomParamTypesEnum} from '../expressionAtomModel';
import {buildEnumParameter, buildParameter} from '../expressionParamHelpers';
import {
  baseMethods,
  CompareMethod,
  MethodCategoriesEnum,
  NumberResult,
  ResultType,
  ResultTypesEnum,
  StaticallyTypedMethod,
} from './internal';

enum NumberComparatorsEnum {
  EQUALS = 'equals',
  NOT_EQUAL = 'not_equal',
  GREATER_THAN = 'greater_than',
  LOWER_THAN = 'lower_than',
}

class NumberCompareMethod extends CompareMethod {
  constructor() {
    super(NumberComparatorsEnum);
  }

  getParameters() {
    const valueParam = buildParameter('value', AtomParamTypesEnum.NUMBER);

    return [buildEnumParameter('operation', NumberComparatorsEnum), valueParam];
  }
}

class AddNumberMethod extends StaticallyTypedMethod {
  constructor() {
    super(MethodCategoriesEnum.TRANSFORM, NumberResult);
  }

  getParameters() {
    return [buildParameter('amount', AtomParamTypesEnum.NUMBER)];
  }
}

export const numberType: ResultType = {
  name: ResultTypesEnum.NUMBER,
  properties: {},
  methods: {
    compare: new NumberCompareMethod(),
    add: new AddNumberMethod(),
    subtract: new AddNumberMethod(),
    ...baseMethods,
  },
};
